import axios from 'axios';

// ─── Derived base URLs ────────────────────────────────────────────────────────
// VITE_API_BASE_URL is the bare host (e.g. https://smarthub-demo-api.lucihub.com).
// Version path segments are appended here — never hard-coded in .env files.
const _base = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8000';
const _timeout = Number(import.meta.env.VITE_API_TIMEOUT ?? 30000);

const baseUrlV2 = `${_base}/api/v2`;
const baseUrlV3 = `${_base}/api/v3`;

// ─── v2 instance — general content, upload, media, storage, trends ───────────
const api = axios.create({
  baseURL: baseUrlV2,
  timeout: _timeout,
  headers: { 'Content-Type': 'application/json' },
});

// ─── v1 instance — auth / login ───────────────────────────────────────────────
// VITE_AUTH_API_BASE_URL already contains the full path including /api/v1
export const authApi = axios.create({
  baseURL: import.meta.env.VITE_AUTH_API_BASE_URL,
  timeout: _timeout,
  headers: { 'Content-Type': 'application/json' },
});

// ─── v3 instance — sections, tags, search ────────────────────────────────────
export const apiV3 = axios.create({
  baseURL: baseUrlV3,
  timeout: _timeout,
  headers: { 'Content-Type': 'application/json' },
});

// ─── Shared interceptor factory ──────────────────────────────────────────────
function attachInterceptors(instance: ReturnType<typeof axios.create>) {
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('auth_token');
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('auth_token');
        window.location.href = '/signin';
      }
      return Promise.reject(error);
    }
  );
}

attachInterceptors(api);
attachInterceptors(apiV3);

export default api;
